<template>
  <div class="province-school-component flex flex-wrap">
    <div class="w-full lg:w-1/2" :class="{'px-2 py-4' : inHome, 'lg:pr-2': !inHome}">
        <v-select
            :items="provincesArray"
            filled
            :rules="[v => !!v || errors.provinces]"
            color="white"
            :dense="onDepositsPage"
            :solo="onDepositsPage"
            :flat="onDepositsPage"
            rounded
            :hide-details="hideDetails"
            :label="lang === 'ca' ? 'Província' : 'Provincia'"
            v-model="province"
            :menu-props="{ bottom: true, offsetY: true }"
        ></v-select>
    </div>
    <div class="w-full lg:w-1/2" :class="{'px-2 py-4' : inHome, 'lg:pl-2': !inHome}">
        <v-select
            :items="schoolsArray"
            filled
            :rules="[v => !!v || errors.schools]"
            color="white"
            :dense="onDepositsPage"
            :solo="onDepositsPage"
            :flat="onDepositsPage"
            rounded
            :hide-details="hideDetails"
            :label="lang === 'ca' ? 'Autoescola' : 'Autoescuela'"
            v-model="school"
            :menu-props="{ bottom: true, offsetY: true }"
        ></v-select>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  props: {
    inHome: {
      type: Boolean,
      default: false
    },
    onDepositsPage: {
        type: Boolean,
        default: false,
    }
  },
  data() {
      return {
        errors: {
            provinces: window.appLocale === 'es' ? '* Provincia obligatorio' : '* Província obligatori',
            schools: window.appLocale === 'es' ? '* Autoescuela obligatorio' : '* Autoescola obligatori',
        }
      }
  },
  computed: {
    ...mapGetters({
      provinces: "provinces",
      schools: "schoolsFilteredByProvince"
    }),
    hideDetails() {
        if (this.inHome) return true;
        if (this.onDepositsPage) return 'auto';
        return false;
    },
    province: {
      get() {
        return this.$store.getters.filterProvince;
      },
      set(payload) {
        this.setFilterProvince(payload);
      }
    },
    school: {
      get() {
        return this.$store.getters.getFormData.school;
      },
      set(payload) {
        console.log(payload);

        this.setSchool(payload);
      }
    },
    schoolsArray() {
      return this.schools.map(school => school.title);
    },
    provincesArray() {
      return this.provinces.map(province => {
        return {
          text: province.name,
          value: province.id
        };
      });
    }
  },
  methods: {
    ...mapMutations(["setFilterProvince", "setSchool"])
  },
  created() {
    this.lang = window.appLocale;
  }
};
</script>
